// Cuartos
export const Q1_MONTHS = ['jan', 'feb', 'mar'];
export const Q2_MONTHS = ['apr', 'may', 'jun'];
export const Q3_MONTHS = ['jul', 'aug', 'sep'];
export const Q4_MONTHS = ['oct', 'nov', 'dec'];

// Obtiene el quarto al que pertenece el mes
export const getQuarterMonth = (month) => {
	if (Q1_MONTHS.includes(month)) return 'q1';
	if (Q2_MONTHS.includes(month)) return 'q2';
	if (Q3_MONTHS.includes(month)) return 'q3';
	if (Q4_MONTHS.includes(month)) return 'q4';

	return 'q1';
};

// Obtiene el nombre del mes
export const getMonthName = (month) => {
	switch (month) {
		case 1:
			return 'Enero';
		case 2:
			return 'Febrero';
		case 3:
			return 'Marzo';
		case 4:
			return 'Abril';
		case 5:
			return 'Mayo';
		case 6:
			return 'Junio';
		case 7:
			return 'Julio';
		case 8:
			return 'Agosto';
		case 9:
			return 'Septiembre';
		case 10:
			return 'Octubre';
		case 11:
			return 'Noviembre';
		case 12:
			return 'Diciembre';
		default:
			return 'Enero';
	}
};

export const months = [
	'jan',
	'feb',
	'mar',
	'apr',
	'may',
	'jun',
	'jul',
	'aug',
	'sep',
	'oct',
	'nov',
	'dec',
];

export const monthsNames = {
	jan: 'Enero',
	feb: 'Febrero',
	mar: 'Marzo',
	apr: 'Abril',
	may: 'Mayo',
	jun: 'Junio',
	jul: 'Julio',
	aug: 'Agosto',
	sep: 'Septiembre',
	oct: 'Octubre',
	nov: 'Noviembre',
	dec: 'Diciembre',
};

// Pre-compute quarter months for better performance
export const QUARTER_MONTHS = {
	all: months,
	q1: Q1_MONTHS,
	q2: Q2_MONTHS,
	q3: Q3_MONTHS,
	q4: Q4_MONTHS,
};

export const MONTH_FIELDS = [
	'pvp',
	'tsu',
	'mg',
	'gmv_local',
	'gmv_usd',
	'profit',
	'cbm',
];
